//通过身份证获取出生日期、性别
function getCardInfo(cardno) {
  let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
  let cardInfo = {
    gender: "",
    birthday: ""
  }
  if (reg.test(cardno) === true) {
    let birthday = "";
    let sexno;
    if (cardno.length == 15) {
      sexno = cardno.substring(16, 17);
      birthday = "19" + cardno.substr(6, 6);
    } else if (cardno.length == 18) {
      sexno = cardno.substring(14, 15);
      birthday = cardno.substr(6, 8);
    }
    if (sexno % 2 == 0) {
      cardInfo.gender = "男"
    } else {
      cardInfo.gender = "女"
    }
    cardInfo.birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
  }
  return cardInfo;
}
// 判断手机号
function isPhone(phonenum) {
  var regex = /^(13[0-9]{9})|(14[0-9]{9})|(15[0-9]{9})|(16[0-9]{9})|(17[0-9]{9})|(18[0-9]{9})|(19[0-9]{9})$/;
  if (!regex.test(phonenum)) {
    return false;
  } else {
    return true
  }
}
//数组排序
function sortArry(arry, value) {
  let newarry = Object.assign([], arry);
  for (var i = 1; i < newarry.length; i++) {
    if (newarry[i][value] < newarry[i - 1][value]) {
      //取出无序序列中需要插入的第i个元素
      let temp = newarry[i];
      //定义有序中的最后一个位置
      var j = i - 1;
      newarry[i] = newarry[j];
      //比较大小，找到插入的位置
      while (j >= 0 && temp[value] < newarry[j][value]) {
        newarry[j + 1] = newarry[j];
        j--;
      };
      newarry[j + 1] = temp;
    }
  }
  return newarry;
}
//判断状态
function getStValStatus(item) {
  let status = {}
  if (item == null || item == undefined || item == '') {
    status.code = 0
    status.stat = false
    return status
  } else {
    status.code = 1
    status.stat = true
    return status
  }
}
// 判断周几
function getWeek(date) {
  var week = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
  var dateM = date.replace(/-/g, "/")
  return week[new Date(dateM).getDay()]
}
// 判断两个经纬度见得距离
function distance(la1, lo1, la2, lo2) {
  var La1 = la1 * Math.PI / 180.0;
  var La2 = la2 * Math.PI / 180.0;
  var La3 = La1 - La2;
  var Lb3 = lo1 * Math.PI / 180.0 - lo2 * Math.PI / 180.0;
  var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(La3 / 2), 2) + Math.cos(La1) * Math.cos(La2) * Math.pow(Math.sin(
    Lb3 / 2), 2)));
  s = s * 6378.137; //地球半径
  s = Math.round(s * 10000) / 10000;
  // console.log("计算结果", s)
  var dis = ''
  if (s * 1000 <= 100) {
    dis = '<100米'
  } else if (s * 1000 < 1000) {
    dis = (s * 1000).toFixed(1) + '米'
  } else {
    dis = s.toFixed(1) + 'km'
  }
  return dis
}

function distancenum(la1, lo1, la2, lo2) {
  var La1 = la1 * Math.PI / 180.0;
  var La2 = la2 * Math.PI / 180.0;
  var La3 = La1 - La2;
  var Lb3 = lo1 * Math.PI / 180.0 - lo2 * Math.PI / 180.0;
  var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(La3 / 2), 2) + Math.cos(La1) * Math.cos(La2) * Math.pow(Math.sin(
    Lb3 / 2), 2)));
  s = s * 6378.137; //地球半径
  s = Math.round(s * 10000) / 10000;
  // console.log("计算结果", s)
  return s
}

function safeTel(tel) {
  var reg = /^(\d{3})\d{4}(\d{4})$/;
  return tel.replace(reg, "$1****$2");
}

// 计算两个时间戳之间相差的天数
function getDaysAndHours(data) {

  var runTime = parseInt(data / 1000); //总时间[秒]

  // 年
  var year = Math.floor(runTime / 86400 / 365); //向下取整
  // 月
  runTime = runTime % (86400 * 365); //取上一个计算剩余的时间
  var month = Math.floor(runTime / 86400 / 30);
  // 日
  runTime = runTime % (86400 * 30);
  var day = Math.floor(runTime / 86400);
  // 时
  runTime = runTime % 86400;
  var hour = Math.floor(runTime / 3600);
  // 分
  runTime = runTime % 3600;
  var minute = Math.floor(runTime / 60);
  // 秒
  runTime = runTime % 60;
  var second = runTime;

  var params = {
    year: year,
    month: month,
    day: day,
    hour: hour,
    minute: minute,
    second: second
  }
  return params
}

function isIphoneX() {
  var u = navigator.userAgent;
  var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  console.log(isIos)
  var screenHeight = window.screenHeight
  if (isIos && screenHeight > 800) {
    return 1
  } else {
    return 0
  }

}

function stringToNumber(data) {
  var num = parseFloat(data, 10)
  return num
}


function getQueryJson(url) {
  // console.log(url)
  if (url && url.indexOf('?') >= 0) {
    var arr = url.split('?');
    let res = arr[1].split('&');
    let items = {};
    for (let i = 0; i < res.length; i++) {
      let a = res[i].split('=');
      items[a[0]] = decodeURIComponent(a[1]);
    }
    return items
  }
}

function datePrintStr2(data) {
  if (data) {

    var ndate = new Date(data)
    // 年月日
    var ndateY = ndate.getFullYear()
    var ndateM = ndate.getMonth() + 1
    if (ndateM < 10) {
      ndateM = '0' + ndateM
    }
    var ndateD = ndate.getDate()
    if (ndateD < 10) {
      ndateD = '0' + ndateD
    }
    // 时分秒
    var ndateHours = ndate.getHours()
    if (ndateHours < 10) {
      ndateHours = '0' + ndateHours
    }
    var ndateMinutes = ndate.getMinutes()
    if (ndateMinutes < 10) {
      ndateMinutes = '0' + ndateMinutes
    }
    var ndateSeconds = ndate.getSeconds()
    if (ndateSeconds < 10) {
      ndateSeconds = '0' + ndateSeconds
    }
    var ndate_hms = ndateHours + ':' + ndateMinutes + ':' + ndateSeconds
    // 周
    var week = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
    var week_short = ['日', '一', '二', '三', '四', '五', '六'];
    // 输出参数
    var param = {
      date_stemp: ndate.getTime(),
      date_nor: ndateY + '/' + ndateM + '/' + ndateD,
      date_hor: ndateY + '-' + ndateM + '-' + ndateD,
      date_pio: ndateY + '.' + ndateM + '.' + ndateD,
      date_pioP: ndateM + '.' + ndateD,
      date_ymd: ndateY + '年' + ndateM + '月' + ndateD + '日',
      date_ymdmd: ndateM + '月' + ndateD + '日',
      date_hms: ndate_hms,
      week: week[ndate.getDay()],
      stamp: ndate.getTime(),
      smonth_day: ndateM + '/' + ndateD,
      smonth_day_md: ndateM + '.' + ndateD,
      week_short: week_short[ndate.getDay()],
      date_ndateD: ndateD,

    }
    return param;
  }
}
// 获取本周数据【默认本周第一天为周一】
function getCurrentWeekDates1() {
  const result = [];
  const today = new Date();
  const startOfWeek = new Date(today);
  startOfWeek.setDate(today.getDate() - today.getDay() + 1);
  for (let i = 0; i < 7; i++) {
    const date = new Date(startOfWeek);
    date.setDate(startOfWeek.getDate() + i);
    result.push(date);
  }

  return result;
}
// 获取本周数据【默认本周第一天为周日】
function getCurrentWeekDates2() {
  const result = [];
  const today = new Date();
  const startOfWeek = new Date(today);
  startOfWeek.setDate(today.getDate() - today.getDay());
  for (let i = 0; i < 7; i++) {
    const date = new Date(startOfWeek);
    date.setDate(startOfWeek.getDate() + i);
    result.push(date);
  }

  return result;
}

function datePrintStr (data) {
    if (data) {
        var n_date = data.replace(/-/g, '/')

        n_date = n_date.replace(/\./g, '/')

        var ndate = new Date(n_date)
        // 年月日
        var ndateY = ndate.getFullYear()
        var ndateM = ndate.getMonth() + 1
        if (ndateM < 10) {
            ndateM = '0' + ndateM
        }
        var ndateD = ndate.getDate()
        if (ndateD < 10) {
            ndateD = '0' + ndateD
        }
        // 时分秒
        var ndateHours = ndate.getHours()
        if (ndateHours < 10) {
            ndateHours = '0' + ndateHours
        }
        var ndateMinutes = ndate.getMinutes()
        if (ndateMinutes < 10) {
            ndateMinutes = '0' + ndateMinutes
        }
        var ndateSeconds = ndate.getSeconds()
        if (ndateSeconds < 10) {
            ndateSeconds = '0' + ndateSeconds
        }
        var ndate_hms = ndateHours + ':' + ndateMinutes + ':' + ndateSeconds
        // 周
        var week = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
        var week_short = ['日', '一', '二', '三', '四', '五', '六'];
        // 输出参数
        var param = {
            date_stemp: ndate.getTime(),
            date_nor: ndateY + '/' + ndateM + '/' + ndateD,
            date_hor: ndateY + '-' + ndateM + '-' + ndateD,
            date_pio: ndateY + '.' + ndateM + '.' + ndateD,
            date_pioP: ndateM + '.' + ndateD,
            date_ymd: ndateY + '年' + ndateM + '月' + ndateD + '日',
            date_ymdmd: ndateM + '月' + ndateD + '日',
            date_hms: ndate_hms,
            week: week[ndate.getDay()],
            stamp: ndate.getTime(),
            smonth_day: ndateM + '/' + ndateD,
            smonth_day_md: ndateM + '.' + ndateD,
            week_short: week_short[ndate.getDay()],
            date_ndateD: ndateD,
            date_ndate_ym: ndateY + '年' + ndateM + '月'
        }
        return param;
    } else {
        var ndate = new Date()
        // 年月日
        var ndateY = ndate.getFullYear()
        var ndateM = ndate.getMonth() + 1
        if (ndateM < 10) {
            ndateM = '0' + ndateM
        }
        var ndateD = ndate.getDate()
        if (ndateD < 10) {
            ndateD = '0' + ndateD
        }
        // 时分秒
        var ndateHours = ndate.getHours()
        if (ndateHours < 10) {
            ndateHours = '0' + ndateHours
        }
        var ndateMinutes = ndate.getMinutes()
        if (ndateMinutes < 10) {
            ndateMinutes = '0' + ndateMinutes
        }
        var ndateSeconds = ndate.getSeconds()
        if (ndateSeconds < 10) {
            ndateSeconds = '0' + ndateSeconds
        }
        var ndate_hms = ndateHours + ':' + ndateMinutes + ':' + ndateSeconds
        // 周
        var week = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
        var week_short = ['日', '一', '二', '三', '四', '五', '六'];
        // 输出参数
        var param = {
            date_nor: ndateY + '/' + ndateM + '/' + ndateD,
            date_hours: ndateHours,
            date_hor: ndateY + '-' + ndateM + '-' + ndateD,
            date_pio: ndateY + '.' + ndateM + '.' + ndateD,
            date_ymd: ndateY + '年' + ndateM + '月' + ndateD + '日',
            date_hms: ndate_hms,
            week: week[ndate.getDay()],
            stamp: ndate.getTime(),
            smonth_day: ndateM + '/' + ndateD,
            week_short: week_short[ndate.getDay()],
            date_ndateD: ndateD
        }
        return param;
    }
}


// 字符串每4格添加一个空格
function expEasyNumber (value) {
    return value.replace(/\s/g, '').replace(/(\w{4})(?=\w)/g, '$1 ')
}
export {
  sortArry,
  getCardInfo,
  isPhone,
  getStValStatus,
  getWeek,
  distance,
  safeTel,
  distancenum,
  getDaysAndHours,
  isIphoneX,
  stringToNumber,
  getQueryJson,
  datePrintStr,
  datePrintStr2,
  getCurrentWeekDates1,
  getCurrentWeekDates2,
  expEasyNumber
}



// WEBPACK FOOTER //
// ./src/lib/utils.js